// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — Rack.styled.classic.js, новая — Rack.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './Rack.styled.classic';
import * as cp from './Rack.styled.cp';

export const Barrier = isCp ? cp.Barrier : classic.Barrier;
export const Barriers = isCp ? cp.Barriers : undefined;
export const CheckingBorder = isCp ? cp.CheckingBorder : undefined;
export const Content = isCp ? cp.Content : classic.Content;
export const Dot = isCp ? cp.Dot : undefined;
export const IconTitle = isCp ? cp.IconTitle : classic.IconTitle;
export const Id = isCp ? cp.Id : classic.Id;
export const OfflineDot = isCp ? cp.OfflineDot : undefined;
export const RackWrapper = isCp ? cp.RackWrapper : undefined;
export const Tip = isCp ? cp.Tip : undefined;
export const TipHint = isCp ? cp.TipHint : undefined;
export const TipMsg = isCp ? cp.TipMsg : undefined;
export const TipOffline = isCp ? cp.TipOffline : undefined;
export const TipOk = isCp ? cp.TipOk : undefined;
export const TipRow = isCp ? cp.TipRow : undefined;
export const TipTitle = isCp ? cp.TipTitle : undefined;
